module.exports = __webpack_public_path__ + "img/logo-2.90a970c5.svg";